<template>
  <v-btn :loading="loading" color="primary" variant="flat" @click="open">
    {{ $t("parts.insert_parts.qr_codes.open_all") }}
    <v-icon end>mdi-qrcode</v-icon>
  </v-btn>
</template>

<script>
import getRequest from "../../api/getRequest";

export default {
  data: () => ({
    loading: false,
  }),
  methods: {
    open() {
      this.loading = true; // start loading
      getRequest(
        "/temporary-part/insert/empty",
        `institution_id=${this.$store.getters.institutionId}&role=${this.$store.getters.role}`,
      )
        .then((response) => {
          this.$emit("parts", response.emptyParts);
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false; // stop loading
        });
    },
  },
};
</script>
